import React from 'react';
import { Modal } from '../Modal';
import { Button } from '../Button';
import { cn } from '../../../utils/cn';

export interface EmailVerificationModalProps {
  isOpen: boolean;
  onClose: () => void;
  email?: string;
  className?: string;
}

export const EmailVerificationModal: React.FC<EmailVerificationModalProps> = ({
  isOpen,
  onClose,
  email,
  className
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="📧 Verification email sent!"
      description="Please verify your email with the link provided in the email."
      className={cn('max-w-sm', className)}
      headerClassName="p-6 pb-0 items-center text-center [&>div]:w-full [&>div]:text-center"
    >
      <div className="space-y-4">
        <p className="text-sm text-muted-foreground">
          {email ? (
            <>We just sent a verification link to <span className="font-semibold text-foreground">{email}</span>. </>
          ) : (
            <>We just sent a verification link to your inbox. </>
          )}
          Confirm your email to get access to Paper Portfolio, Private Leaderboards, Sentiment Voting, Statistics, and more!
        </p>
        <Button onClick={onClose} className="w-full font-semibold">
          Got it
        </Button>
      </div>
    </Modal>
  );
};

export default EmailVerificationModal;
